import React, {memo, useEffect} from 'react';
import { history } from 'umi';
import classNames from "classnames";
import {Layout} from 'tea-component';
import Tabs from '@intelligence/components/NewIconTabs';
import DashboardLayout from "@/pages/datalab/components/DashboardLayout";
import {EntryDashboardPath} from "@/pages/datalab/core/global/types";
import {useDashboardReportStore} from "@/pages/datalab/components/DashboardLayout/hooks";
import {setLocaleState} from "@home/utils/state";
import {fetchDateEvents} from "@/pages/datalab/core/global/utils";
import AIAnalysisButton from './components/AIAnalysisButton';
import './index.scss';

// 仅在 datalab 自定义报表（经分承接页 /dashboard/.../datalab/customDashboard）下展示 AI 分析按钮
const SYSTEM_DATALAB_CUSTOM_DASHBOARD = 'dashboard';

const { Body, Content } = Layout;
export const CommonDashboardReport = memo((props: any) => {
  const { system, dashboardId, dashboardName, gameCode, handleDashboardInfoThen, className, reportInfo, attributes, ...otherProps} = props;
  const { tabId } = props.location?.query || {};
  /**
   * dashboardName
   * 经分承接页面的 左上角标题和菜单名称保持一致, 通过外界传递的 dashboardName
   * benchmark的承接页面不需要标题展示, 可以不传递
   */

  // 报表显示的数据状态和逻辑
  const { headerTabs, tabLayouts, currentTabId, setCurrentTabId, filters, userFilter, layouts, showContact, contactInfo, dashboardInfoRunAsync, dashboardInfoLoading, dashboardInfoError, chartsInfoLoading, dashboardInfo } = useDashboardReportStore({system, gameCode, dashboardId, attributes, defaultTabId: tabId});

  // 发起报表信息请求
  useEffect(() => {
    dashboardId && dashboardInfoRunAsync({game_code: gameCode, id: dashboardId, system}).then((res) => {
      handleDashboardInfoThen?.(res);
    }).catch((e) => {
      console.error('报表信息请求错误', e);
    });
    
    // 发起日期筛选器内部使用的Event数据请求.
    fetchDateEvents(gameCode, EntryDashboardPath.CommonDashboard);

    // 存储用于承接页面内部 按钮打点的信息
    setLocaleState('datalabReportInfo', {dashboardName, dashboardId, gameCode, ...reportInfo});
    // {
    //       gameCode: '',
    //       gameName: '',
    //       uid: '',
    //       typeId: '',
    //       reportPageId: '',
    //       dashboardName: '',
    //       dashboardId: '',
    //       pageName: '',
    //     }

    return () => {
      setLocaleState('datalabReportInfo', undefined);
    };

  }, [dashboardId]);

  return (
    <Layout className={classNames('dbh-common-dashboard-report', className, {'dbh-common-dashboard-report-with-tabs': !dashboardName && headerTabs.length > 0})}>
      <Body>
        <Content>
          <Content.Header
            title={
              system === SYSTEM_DATALAB_CUSTOM_DASHBOARD
                ? (
                  <AIAnalysisButton
                    dashboardName={dashboardName}
                    gameCode={gameCode}
                    dashboardId={dashboardId}
                    gameName={reportInfo?.gameName}
                    pageId={reportInfo?.reportPageId}
                  />
                )
                : dashboardName
            }
            className={classNames({
              'dbl-dashboard-header-with-tabs': headerTabs.length > 0,
              'dbl-dashboard-without-header': !dashboardName && headerTabs.length === 0,
            })}
          >
            <Tabs
              newMarkIdsMappingKey="IPLibrary"
              tabs={headerTabs}
              activeId={currentTabId}
              onActive={(tab) => {
                setCurrentTabId(tab.id);
                history.replace({
                  pathname: history?.location?.pathname,
                  query: {
                    ...(history?.location?.query || {}),
                    tab: typeof tab?.label === 'string' ? tab?.label : tab?.id,
                    tabId: tab?.id,
                  }
                });
              }}
              className={'dbl-dashboard-header-tabs'}
            />
          </Content.Header>
          <Content.Body>
            <DashboardLayout
              key={currentTabId}
              system={system}
              gameCode={gameCode}
              dashboardId={dashboardId}
              tabLayouts={tabLayouts}
              filters={filters}
              userFilter={userFilter}
              layouts={layouts}
              loading={dashboardInfoLoading}
              error={dashboardInfoError}
              // 报表内渲染的图表信息请求加载态
              chartsInfoLoading={chartsInfoLoading}
              showContact={showContact}
              contactInfo={contactInfo}
              chartExplore={dashboardInfo?.exploratory}
              {...otherProps}
            />
          </Content.Body>
        </Content>
      </Body>
    </Layout>
  );
});

